$(document).ready(function () {

    // Read a page's GET URL variables and return them as an associative array.
    function getUrlVars() {
        var vars = [], hash;
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for (var i = 0; i < hashes.length; i++) {
            hash = hashes[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];
        }
        return vars;
    }

    //Function to Re-initialize Infinite Scroll when dynamic content is loaded
    function resetInfiniteScroll() {

        var $nextLink = $('.pagination__next');

        if (!$nextLink.length) {
            $('.view-more-button').hide();
            return;
        } else {
            $('.view-more-button').attr("style", "");
        }
        var infiniteIncrement = $('.post > div').length;
        var $container = $('.infinite-tiles').infiniteScroll({
            path: function () {
                var pageNumber = (this.loadCount + 1) * infiniteIncrement;
                if ($(this.element).find('.pagination__next').length > 0) {
                    var path = $(this.element).find('.pagination__next').attr('href');
                    path = path.substring(0, path.length - 3);
                    return path + 'P' + pageNumber + '/';
                }
            },
            append: '.post',
            button: '.view-more-button',
            status: '.page-load-status',
            checkLastPage: '.pagination__next',
            history: false,
        });
        var infScroll = $container.data('infiniteScroll');
        $container.on('load.infiniteScroll', onPageLoad);
        function onPageLoad() {
            if (infScroll.loadCount == 1) {
                if (typeof ga === 'function') {
                    ga('send', 'event', 'load-more', 'lazyload', infScroll.getPath());
                }
                if (typeof gtag === 'function') {
                    gtag("event", 'lazyload', { event_category: 'load-more', event_label: infScroll.getPath() });
                }
                $container.infiniteScroll('option', {
                    loadOnScroll: false,
                });
            }
        }
    }

    //Function to load in section (homepage, webinars) with filter (latest, webinars, etc)
    function loadDynamicSection(section, filter) {
        $('#' + section + ' .loader-wheel').removeClass('hidden');

        if (section == "homepage_articles") {
            //articles section
            $('.listing-dropdown-open').each(function () {
                $(this).removeClass('listing-dropdown-open');
                $(this).find('a i').removeClass('text-ctl-red');
                $(this).find('div').slideUp(100);
            });
            $('.tech-days-button').removeClass('active');
            $('.tech-days-button span').addClass('hidden');

            var navButton = $('.listing-header').find("[data-filter='" + filter + "']");

            navButton.addClass('active');
            if (navButton.hasClass('dropdown-item')) {
                navButton.closest('.group').find('>a').addClass('active');
                navButton.closest('.group').find('span').removeClass('hidden');
            }

            //Destroy previous instance of Infinite Scroll
            var infScroll = InfiniteScroll.data('.infinite-tiles');
            if (infScroll) {
                infScroll.destroy();
            }

            var dynamic_url = window.location.href;
            if (dynamic_url.substr(-1) != '/') dynamic_url += '/';

            dynamic_url += section + '/' + filter + '/';
            if ($('#tech-days-categories').val() != "") {
                dynamic_url += "category/" + $('#tech-days-categories').val() + "/";
            }

            $('#' + section).load(dynamic_url + " #" + section + " .infinite-tiles", function () {
                $('#' + section + ' .loader-wheel').addClass('hidden');
                resetInfiniteScroll();
            });

        } else {
            //webinars section
            $('.tech-days-circle').removeClass('selected');
            $('*[data-filter="' + filter + '"]').find('.tech-days-circle').addClass('selected');
            $('#' + section).load(section + '/' + filter + '/' + " #" + section, function () {
                $('#' + section + ' .loader-wheel').addClass('hidden');
                $("#webinars").trigger("timezoneUpdate");
            });
        }
    }

    $('.all-button').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $('.tech-days-checkboxes input:checkbox:checked').each(function () {
            $(this).prop('checked', false);
        });
        $('#tech-days-categories').val("");
        $('.all-button-wrapper').addClass('active-category');
        var filter = $('.listing-header .active').data('filter') || "latest";
        loadDynamicSection('homepage_articles', filter);
    });

    $('.tech-days-checkboxes input').change(function () {
        if ($(this).hasClass("parent-category")) {
            var subcategories = $(this).closest('.parent-container').next('.child-container');

            if ($(this).is(":checked")) {
                subcategories.find('.child-category').each(function () {
                    $(this).prop("checked", true);
                });
            }
            else {
                subcategories.find('.child-category').each(function () {
                    $(this).prop("checked", false);
                });
            }

        } else if ($(this).hasClass("child-category")) {
            var subcategories = $(this).closest('.child-container');
            var parent = subcategories.prev('.parent-container').find('.parent-category');
            var total_checkboxes = subcategories.find('input').length;
            var num_checked = subcategories.find('input:checked').length;


            if (total_checkboxes == num_checked) {
                parent.prop("checked", true);
            } else {
                parent.prop("checked", false);
            }


        }
        $('.all-button-wrapper').removeClass('active-category');
        var categories = "";
        $('.tech-days-checkboxes input:checkbox:checked').each(function () {
            categories += $(this).val() + "-";
        });
        $('#tech-days-categories').val(categories.slice(0, -1));

        if (categories == "") {
            $('.all-button-wrapper').addClass('active-category');
        }
        var filter = $('.listing-header .active').data('filter') || "latest";
        loadDynamicSection('homepage_articles', filter);
    });

    $('.tech-days-button').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var section = $(this).data('section');
        var filter = $(this).data('filter');
        loadDynamicSection(section, filter);
    });

    $('.tech-days-mobile-dropdown').change(function () {
        var section = $(this).data('section');

        var dropdown_val = $(this).val();
        var filter = "";
        if (section == "homepage_articles") {
            filter = $('.listing-header .active').data('filter') || "latest";
            if (dropdown_val > 0) {
                $('#tech-days-categories').val(dropdown_val);
            } else {
                $('#tech-days-categories').val("");
            }
        } else {
            filter = dropdown_val;
        }
        loadDynamicSection(section, filter);
    });



    /*
        Keynote Slider
    */
    $(".what-theyre-saying").slick({
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
    });


    var category_id = getUrlVars()["category"];
    if (category_id != null) {
        category_id = category_id.replace("/", "");

        $('.all-button-wrapper').removeClass('active-category');
        $('.tech-days-checkboxes input:checkbox').each(function () {
            if ($(this).val() == category_id) {
                $(this).prop("checked", true);
                $(this).trigger("change");
                if ($(this).hasClass("child-category")) {
                    var subcategories = $(this).closest('.child-container');
                    var parent = subcategories.prev('.parent-container').find('i');
                    parent.trigger("click");
                }


                $('html, body').animate({
                    scrollTop: $("#homepage_articles").offset().top
                }, 1000);
            }
        });
    }

    var mmdd = moment(new Date()).tz('America/Denver').format('M-D');

    $('.tech-days-button[data-filter="' + mmdd + '"]').trigger('click');
    if ($('.tech-days-mobile-dropdown[data-section="homepage_webinars"] option[value="' + mmdd + '"]').length > 0) {
        $('.tech-days-mobile-dropdown[data-section="homepage_webinars"]').val(mmdd).select();
    }
    resetInfiniteScroll();

    var hash = window.location.hash.substr(1);

    if (hash == "my_schedule") {
        showSubscriberSchedule('/json/tech-days-subscriber-schedule/', '#subscriber-schedule-container');
    }

    const adjustBottomGfx = () => {
        if ($('#bottom-gfx.event-').length > 0) {
            const { top } = $('#why-attend').offset()
            const height = $('#why-attend').height()
            const newPosition = top + height + 170;
            $('#bottom-gfx.event-').offset({ top: newPosition });
        }
    }

    adjustBottomGfx();

    $(window).on('resize', () => {
        adjustBottomGfx();
    });
});